import { motion } from 'framer-motion';
import SectionHeading from './SectionHeading';
import { clientSteps } from '@/lib/siteData';

const ClientProcess = () => {
  return (
    <section className="bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          eyebrow="Servicio al cliente"
          title="DESARROLLO DEL SERVICIO"
          text="Un proceso claro desde la primera propuesta hasta la atención continua."
        />

        <div className="mt-14 grid gap-5 lg:grid-cols-3">
          {clientSteps.map(([title, description], index) => (
            <motion.article
              key={title}
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: (index % 3) * 0.08 }}
              className="relative border border-slate-200 p-7 before:absolute before:left-0 before:top-0 before:h-1 before:w-16 before:bg-emerald-500"
            >
              <span className="text-xs font-bold uppercase tracking-widest text-[#94cf1c]">
                Paso 0{index + 1}
              </span>
              <h3 className="mt-7 text-xl font-bold uppercase text-[#0A2540]">
                {title}
              </h3>
              <p className="mt-4 leading-7 text-slate-600">
                {description}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientProcess;